// What differs between the places that create and edit assessment tasks with TaskDialog (US 9398).
// The dialog holds the form; an adapter says where it is saved and which parts it has.
//
//   features.linkedControls   links to tasks in other templates (templates only)
//   features.defaultTexts     pre-filled text for the auditor's fields (templates only; a project task has the text itself)
//   features.defaultOptions   "Use template default" for drop-downs (templates only; project tasks have their own copy)
//   features.questionnaire    a contextual (risk) question with one respondent: no documentation collection, controls,
//                             period audit or auditor's fields; only the description, response, comment and attachments
//   nameField                 the task's name on update ("name" on questions, "title" on project tasks)
//   load(task)                fetches a saved task with its files, links and controls
//   create(formData)          saves a new task, resolves to it
//   update(task, payload)     saves an existing task, resolves to it
//   modelType(task)           the model files and links are attached to
//   duplicateReference(ref, task)   resolves to true when another task already uses the reference
import piincHttp from '@/util/configureAxios.js';

export function templateAdapter(assessment, client) {
  return {
    features: { linkedControls: true, defaultTexts: true, defaultOptions: true, questionnaire: assessment.type === 'risk' },
    nameField: 'name',
    load(task) {
      return piincHttp.get('questions/' + task.slug, { params: { client: client.slug } }).then(response => response.data);
    },
    create(formData) {
      formData.append('assessment_id', assessment.id);
      return piincHttp.post('questions', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(response => response.data);
    },
    update(task, payload) {
      return piincHttp.put('questions/' + task.slug, payload).then(response => response.data);
    },
    modelType(task) {
      return task.who_am_i;
    },
    duplicateReference(reference, task) {
      return piincHttp.get('questions', { params: { per_page: 2, reference: reference, assessment: assessment.id, client: client.slug } })
        .then(response => response.data.items.some(item => !task || item.id !== task.id));
    }
  };
}

// A project's own tasks: saved on the project, in the project's own control objectives. They have no linked
// controls, no default texts and no default drop-downs; each task holds its own text and options.
export function projectAdapter(project) {
  return {
    features: { linkedControls: false, defaultTexts: false, defaultOptions: false, questionnaire: project.type === 'risk_assessment' },
    nameField: 'title',
    load(task) {
      return piincHttp.get('tasks/' + task.id).then(response => response.data);
    },
    create(formData) {
      // A new task is named by "name", and its objective is one of the project's own
      formData.append('name', formData.get('title'));
      formData.delete('title');
      if (formData.has('control_objective_id')) {
        formData.append('project_control_objective_id', formData.get('control_objective_id'));
        formData.delete('control_objective_id');
      }
      return piincHttp.post('projects/' + project.slug + '/task-create', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(response => response.data);
    },
    update(task, payload) {
      return piincHttp.put('tasks/' + task.id, payload).then(response => response.data);
    },
    modelType(task) {
      return task.who_am_i;
    },
    // Project tasks have no reference lookup
    duplicateReference() {
      return Promise.resolve(false);
    }
  };
}
